import Auth from "utils/auth/Auth";
import querystring from "query-string";
import {history} from "store";
import {setAccessToken} from "utils/clients";
import _ from "lodash";
import externals from "utils/externals";
import {setUserId} from "utils/localstorage";
import { setFullStory, setGoogleAnalytics, trackGaBeforeLogin } from "utils/ga";
import { handlePromiseAction } from "utils/actions";
import { matchPath } from "react-router-dom";
import { trackEvent, trackTiming } from "utils/mrTracker";
import { apiClient } from 'utils/clients';
import { logUserActions } from "utils/auth/common";
import { getLocalizedValue as t} from "../../../i18n";
import { appComponents as i18nNamespace } from "../../../i18n/namespace";

const handleLocationReplacements = authResult => {
    const search = querystring.parse(window.location.search);

    if (authResult.paramsForUI.pathname) { // pathname received from login page. Navigate to it.
        const path = authResult.paramsForUI.pathname.startsWith('/') ? authResult.paramsForUI.pathname : `/${authResult.paramsForUI.pathname}`;
        history.replace(path);
    } else {
        delete search.redirectToLogin;
        delete search.paramsForLoginPage;
        const searchString = querystring.stringify(search);

        history.replace(window.location.pathname + (searchString ? `?${searchString}` : '') + window.location.hash);
    }
};

let auth = null;
let loggedinUserId = null;
let testAppAuth = null;
const emailRegex = /^(?=.{0,255}$)[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.([a-zA-Z]{2,20})$/;
export default ({dispatch, getState}) => next => async (action) => {
    const {type, payload} = action;

    if (type === "AUTH:INITIALIZE") {
        const {domain, clientId: clientID, audience, testClientId} = payload;
        const search = querystring.parse(window.location.search);
        /*
         * For AIQ user migration check if the email is part of the URL
         * Also validate the email id.
         */
        const email = emailRegex.test(search.email) ? search.email : undefined;
        delete search.email;
        dispatch({
            type: 'AUTH:LOGIN-PENDING'
        })
        auth = new Auth({
            clientID,
            domain,
            audience
        }, {baseUrl: externals.portalFrontend});

         if (!_.isUndefined(testClientId)) {
            testAppAuth = new Auth({
                clientID: testClientId,
                domain,
                audience
            }, {baseUrl: externals.portalFrontend});
        }

        window.__auth = auth;
        window.__testAppAuth = testAppAuth;

        if (window.location.pathname === "/federated-connection-test") {
            dispatch({
                type: "AUTH:TEST-REFRESH-SSO",
                payload: { email }
            });
        } else {
            dispatch({
                type: "AUTH:REFRESH-SSO",
                payload: { email }
            });
        }
    } else if (type === "AUTH:REFRESH-SSO") {
        const email  = payload?.email;
        const loginSuccess = (authResult) => {
            const userId = _.get(authResult, "idTokenPayload.sub");
            setAccessToken(authResult.accessToken);
            setUserId({userId});
            setGoogleAnalytics(authResult);
            setFullStory(authResult);

            dispatch({
                type: "AUTH:REFRESH-SSO-SUCCESS",
                payload: authResult
            });

            loggedinUserId = userId
            
            if (authResult.isRefreshUser) {
                logUserActions("REFRESH_USER", loggedinUserId)
            } else {
                logUserActions("LOGIN_USER", loggedinUserId)
            }

            dispatch({ type: "APP:HANDLE-GTC-CHECK" });
            
            setTimeout(() => {
                dispatch({
                    type: "AUTH:RENEW-SSO"
                });
            }, authResult.expiresIn * 1000 - 35000);

            trackTiming({ category: "Auth", name: "BlueXP_UI_login" });
            trackEvent({
                event_category: 'user_login',
                action: "BlueXP_UI_login",
                label: 'UserId',
                value : userId
            });

            handleLocationReplacements(authResult);
        };

        const loginFail = () => {
            dispatch({
                type: "AUTH:REFRESH-SSO-FAILED",
                payload: {email}
            });
        };

        auth.refreshSso(undefined, {pathname: window.location.pathname + window.location.search + window.location.hash}, undefined, email).then(loginSuccess, loginFail);
    }  else if (type === "AUTH:TEST-REFRESH-SSO") {
            const loginSuccess = async authResult => {
                try {
                    setAccessToken(authResult.accessToken);
                    const organizationId = authResult.paramsForUI.organizationId;
                    const federationId = authResult.paramsForUI.federationId;
                    const url =`${externals.federationBackend}/organizations/${organizationId}/federations`;
                    const federations = await apiClient.get(`${url}?filter=auth0Id eq '${authResult.idTokenPayload['http://cloud.netapp.com/connection_id']}'`)
                    const selectedFederation = federations?.data?.items?.length > 0 ? federations?.data?.items.filter(federation => federation.id === federationId) : undefined;
                    if (_.isUndefined(selectedFederation) || selectedFederation?.length === 0) {
                        loginFail({ error: 'Error in testing connection', errorDescription: "Email used to test the connection is not associated with any federation"})
                    } else {
                        if (selectedFederation[0].state !== "ENABLED") {
                            await apiClient.patch(`${url}/${selectedFederation[0].id}`, {
                                stateDesired: "TESTED",
                                type: "application/vnd.netapp.bxp.federation",
                                version: "1.0"
                            })
                        }
                        dispatch({
                            type: "AUTH:TEST-FEDERATION-CONNECTION-SUCCESS",
                            payload: { selectedFederation }
                        });
                    }
                } catch(err) {
                    loginFail({error: err?.response?.data?.title, errorDescription: err?.response?.data?.description})
                }
            };

            const loginFail = (err => {
                dispatch({
                    type: "AUTH:TEST-FEDERATION-CONNECTION-ERROR",
                    payload: { err }
                });
            });
            testAppAuth.testRefreshSso().then(loginSuccess, loginFail);
    } else if (type === "AUTH:REFRESH-SSO-FAILED") {
        trackGaBeforeLogin();
        const paramsForLoginPage = {}
        const email = payload?.email;
        const match = matchPath(window.location.pathname,'/app-redirect/:app')
        if (email) {
            paramsForLoginPage.email = email
        }
        if(match){
            paramsForLoginPage.service = match.params.app
        }
        auth.loginRedirect({}, paramsForLoginPage, {pathname: window.location.pathname + window.location.search + window.location.hash});
    } else if (type === "AUTH:LOGOUT") {
        logUserActions("LOGOUT_USER", loggedinUserId)
        auth.logout();
    } else if (action.type === "AUTH:RENEW-SSO") {
        const loginSuccess = (authResult) => {
            setAccessToken(authResult.accessToken);

            const currentUserId = _.get(getState(), "auth.userId");
            const newUserId = _.get(authResult, "idTokenPayload.sub");

            if (currentUserId !== newUserId) {
                console.log("Newly logged in user is different from previous.. reloading app..");
                window.location.reload();
            }

            dispatch({
                type: "AUTH:REFRESH-SSO-SUCCESS",
                payload: authResult
            });

            logUserActions("REFRESH_USER", loggedinUserId)

            setInterval(() => {
                dispatch({
                    type: "AUTH:RENEW-SSO"
                });
            }, authResult.expiresIn * 1000 - 35000);

        };

        const loginFail = (err) => {
            if (err.error === "timeout") {
                // This error happens when auth0 does not return a response within the expected time.
                dispatch({
                    type: "AUTH:RENEW-SSO-TIMEOUT"
                });
            } else {
                dispatch({
                    type: "AUTH:REFRESH-SSO-FAILED"
                });
            }
        };

        auth.refreshSso().then(loginSuccess, loginFail);
    } else if (type === "AUTH:AUTO-LOGOUT") {
        logUserActions("LOGOUT_USER", loggedinUserId);
        auth.logout();
    } else if (type === "AUTH:THIRD-PARTY-AUDIENCE") {
        const state = getState();
        if(!state.auth.isFetchingThirdPartyToken && !state.auth.thirdPartyToken) {
            const p = handlePromiseAction(action, () => {
                return auth.refreshSso({audience: "https://3p1c.cloud.netapp.com"}, null, true);
            })

            p.catch(e => {
                dispatch({
                    type: "NOTIFICATIONS:ERROR",
                    payload: {
                        message: t("failed_to_obtain_access_token",i18nNamespace),
                        moreInfo: e?.errorDescription
                    }
                })
            })
        }
    }

    return next(action);
}
